<script>
import { mapActions, mapState } from 'vuex';
import ReminderTemplateEdit from '../../components/Reminders/ReminderTemplateEdit';
import dateMixin from '../../mixins/dateMixin';

export default {
  name: 'ReminderTemplates',
  components: {
    ReminderTemplateEdit,
  },
  mixins: [
    dateMixin,
  ],
  data() {
    return {
      edit: false,
      template: undefined,
      type: 'create',
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Subject', value: 'subject' },
        { text: 'Attachments', sortable: false },
        { text: 'Created', value: 'createdAt' },
        { text: 'Updated', value: 'updatedAt' },
        { text: 'Action', sortable: false, width: '40px', class: 'text-xs-center' },
      ],
      pagination: {
        rowsPerPage: 25,
        page: 1,
        sortBy: 'Created',
      },
      domainId: undefined,
    };
  },
  methods: {
    ...mapActions({
      setBreadcrumbs: 'nav/setBreadcrumbs',
      setDomain: 'reminders/setTemplateDomain',
      getDomains: 'reminders/loadDomains',
      getTemplates: 'reminders/getTemplates',
    }),
    domainChanged(domainId) {
      const foundDomain = this.domains.items.find(domain => domain.id === domainId);
      this.setDomain(foundDomain);
    },
    createTemplate() {
      this.$set(this, 'template', undefined);
      this.edit = !this.edit;
      this.type = 'create';
    },
    editTemplate(template) {
      this.template = template;
      this.edit = !this.edit;
      this.type = 'edit';
    },
    refreshTemplates() {
      this.getTemplates(this.domain.id);
    },
  },
  computed: {
    ...mapState({
      domains: state => state.reminders.domains,
      templates: state => state.reminders.templates.templates,
      domain: state => state.reminders.templates.domain,
    }),
    disableDomains() {
      return this.domains.loading ||
        this.domains.error ||
        this.domains.noContent ||
        this.templates.loading;
    },
  },
  created() {
    this.setBreadcrumbs({
      breadcrumbs: [
        { text: 'Reminders', to: '', disabled: true },
        { text: 'Templates', to: this.$route.path },
      ],
      title: 'Templates',
    });
    if (!this.domains.items.length && !this.domains.loading) {
      this.getDomains().then(() => {
        if (this.$route.query.domain) {
          const domainId = parseInt(this.$route.query.domain, 10);
          this.setDomain(this.domains.items.find(domain => domain.id === domainId));
          this.domainId = domainId;
        }
      });
    }
  },
};
</script>
<template>
  <v-flex xs12>
    <v-card>
      <v-container grid-list>
        <v-layout row>
          <v-flex xs6>
            <v-autocomplete
              :value="domainId"
              :items="domains.items"
              :loading="domains.loading"
              :disabled="disableDomains"
              label="Choose Domain"
              item-value="id"
              item-text="name"
              dense
              @change="domainChanged"
            />
          </v-flex>
          <v-flex xs6>
            <v-btn
              @click="createTemplate"
              :disabled="!domain || templates.loading"
              color="blue"
              class="white--text reminder-templates__create"
            >
              Create
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout row mt-4>
          <v-flex xs11 headline>
            Templates
          </v-flex>
          <v-flex xs1 text-xs-right>
            <v-btn
              @click="refreshTemplates"
              :disabled="templates.loading || domains.loading || !domain"
              :class="{ 'icon-spin': templates.loading }"
              icon
            >
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-divider/>
        <v-layout row mt-4>
          <v-flex v-if="domain" xs12>
            <v-data-table
              :headers="headers"
              :pagination.sync="pagination"
              :items="templates.items"
              :loading="templates.loading"
            >
              <template v-slot:items="props">
                <tr>
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.subject }}</td>
                  <td>
                    <template v-if="props.item.attachments.length">
                      {{ props.item.attachments.map(a => a.name).join(', ') }}
                    </template>
                    <span v-else class="caption text--grey">
                      -
                    </span>
                  </td>
                  <td>{{ formatDate(props.item.createdAt) }}</td>
                  <td>{{ formatDate(props.item.updatedAt) }}</td>
                  <td class="d-flex align-center">
                    <v-btn
                      @click="editTemplate(props.item)"
                      :disabled="templates.loading || domains.loading"
                      color="blue"
                      small
                    >
                      <v-icon color="white" small>edit</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-slot:no-data>
                <v-flex xs12 text-xs-center>
                  <v-alert v-if="templates.error" :value="true" type="error">
                    Unable to load templates
                  </v-alert>
                  <span v-else-if="!templates.loading" class="caption grey--text font-italic">
                    No Templates found
                  </span>
                </v-flex>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex v-else xs12 text-xs-center>
            <span class="caption grey--text">
              Select a domain to see templates
            </span>
          </v-flex>
        </v-layout>

        <reminder-template-edit
          :show="edit"
          :template="template"
          :type="type"
        />
      </v-container>
    </v-card>
  </v-flex>
</template>

<style lang="scss">
.reminder-templates {
  &__create {
    float: right;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/reminders/ReminderTemplates.vue